
import { Component, Vue } from 'vue-property-decorator'
import TagList from '@/components/tag/TagList.vue'

@Component({
  name: 'Tags',
  components: { TagList }
})
class Tags extends Vue {}

export default Tags
